module.exports = __webpack_public_path__ + "static/img/onramper.9ca1280.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/onramper.svg
// module id = d0JU
// module chunks = 2